import styled from 'styled-components'

const Status = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  cursor: pointer;
`

const Container = styled.div`
  width: fit-content;
`

export const s = { Status, Container }
